module.exports = __webpack_public_path__ + "img/modal_illustration_paywall.2f744053.jpeg";